import {
  USER_INDEX,
  WORKSPACE_GROUP_INDEX,
} from "@/components/pieces/algolia/indexes";

import { EmailSuggestionItem } from "./EmailSuggestionItem";
import { GroupSuggestionItem } from "./GroupSuggestionItem";

export function SuggestionItem({ suggestion, isTag = false, status = null }) {
  const suggestionIndexName = suggestion?._indexName;

  const isUserSuggestion = suggestionIndexName === USER_INDEX;
  const isGroupSuggestion = suggestionIndexName === WORKSPACE_GROUP_INDEX;

  return (
    <>
      {isUserSuggestion && (
        <EmailSuggestionItem
          suggestion={suggestion}
          isTag={isTag}
          status={status}
        />
      )}

      {isGroupSuggestion && <GroupSuggestionItem suggestion={suggestion} />}
    </>
  );
}
